// Disable hover effects on mobile devices for product cards
document.addEventListener('DOMContentLoaded', function() {
  function disableHoverOnMobile() {
    if (window.innerWidth <= 749) {
      const galleries = document.querySelectorAll('.card-gallery');
      galleries.forEach(function(gallery) {
        // Remove existing hover event listeners if they exist
        if (gallery._previewImageHandler) {
          gallery.removeEventListener('pointerenter', gallery._previewImageHandler);
        }
        if (gallery._resetImageHandler) {
          gallery.removeEventListener('pointerleave', gallery._resetImageHandler);
        }
        
        // Create disabled handlers that prevent the default hover behavior
        gallery._previewImageHandler = function(e) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        };
        gallery._resetImageHandler = function(e) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        };
        
        // Add the disabled handlers
        gallery.addEventListener('pointerenter', gallery._previewImageHandler);
        gallery.addEventListener('pointerleave', gallery._resetImageHandler);
      });
    }
  }
  
  // Run on initial load
  disableHoverOnMobile();
  
  // Run on window resize
  window.addEventListener('resize', disableHoverOnMobile);
}); 